/**
 * Modules de l'application, affichés comme tuiles sur l'écran d'accueil.
 * Décision de Jasmin (4 nov. 2026) : l'accueil s'affiche à chaque ouverture,
 * seulement si la personne a accès à au moins deux modules ; sinon elle
 * arrive directement dans son seul module.
 *
 * Ajouter un module : une entrée ici + son écran dans App.tsx. Les rôles
 * ne servent qu'à l'affichage : la protection réelle est en base (RLS).
 */
import type { Profil, RoleGlobal } from './types'

export type CleModule = 'chantiers' | 'crm'

export interface ModuleApp {
  cle: CleModule
  nom: string
  description: string
  roles: RoleGlobal[]
}

export const MODULES: ModuleApp[] = [
  {
    cle: 'chantiers',
    nom: 'Chantiers',
    description: 'Plans, photos, devis, suivis',
    roles: ['consultation', 'chef', 'admin', 'superadmin']
  },
  {
    cle: 'crm',
    nom: 'CRM',
    description: 'Compagnies, contacts, relances',
    roles: ['admin', 'superadmin']
  }
]

export function modulesDisponibles(profil: Profil | null): ModuleApp[] {
  if (!profil?.actif) return []
  return MODULES.filter((m) => m.roles.includes(profil.role))
}
